<template>
  <v-card
      class="rounded-lg white--text"
      :color="(report_type==='net')?'secondary':'primary'"
      height="370"
  >
    <v-card-title class="text-md-h6 mr-3 mt-3">
      {{title}}
      <v-spacer></v-spacer>
      <v-btn fab icon class="mr-3" href="/report/incomeStatement" target="_blank">
        <v-img class="" src="/img/icons/info-white.svg" max-width="23"></v-img>
      </v-btn>
    </v-card-title>
    <v-card-text class="text-h4 white--text">
      {{ result.amount | toMoney}} ریال
    </v-card-text>
    <v-divider class="mt-12 white ml-3 mr-3 mb-1"></v-divider>
    <p class="mt-2 mr-3">نسبت حاشیه {{ title }} {{ result.profitPercent }} %</p>
  </v-card>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "ProfitMarginCard",
  components: {
  },
  props: {
    id: {},
    report_type: {
      default: 'net',
    }
  },
  data() {
    return {
      result: null,
    };
  },
  mounted() {
    this.getDataFromApi()

  },
  methods : {
    getDataFromApi(){
      this.request({
        url: this.endpoint(`reports/pureProfitCardReport/${this.report_type}`),
        method: "get",
        success: data => {
          this.result = data
        }
      })
    },

  },

  computed: {
    title(){
      if (this.report_type == 'net') {
        return 'سود خالص'
      } else {
        return 'سود نا خالص'
      }
    },
  },


}
</script>

<style scoped lang="scss"></style>

